module.exports = __webpack_public_path__ + "static/media/keyframe_arrows_v2.dee052e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/svg/keyframe_arrows_v2.svg
// module id = 7400
// module chunks = 0